import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignItemConfig,
  ReportDesignItemGrid
} from "../../report-design-item";

@Pipe({
  name: "asGridConfig",
  standalone: false
})
export class ReportItemConfigAsGridPipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignItemGrid {
    return <ReportDesignItemGrid>value;
  }
}
